import { useEffect, useState } from 'react';

import { handleError } from '@/services/handleError';
import { useAppSelector } from '@/store';
import type { TDocumentsOnModeration } from '@/types/uploadFiles';

const useModerationDocuments = () => {
  const { selectedBank } = useAppSelector((state) => state.financingStep);

  const [documentsOnModeration, setDocumentsOnModeration] = useState<
    TDocumentsOnModeration[]
  >([]);

  useEffect(() => {
    try {
      const parsedLogBody = JSON.parse(
        selectedBank?.responseApprovedBody || '{}'
      );
      if (
        parsedLogBody?.modification &&
        selectedBank?.status.code === 'on_rework'
      ) {
        setDocumentsOnModeration(parsedLogBody.modification);
      }
    } catch (error) {
      handleError(error);
    }
  }, [selectedBank]);

  return { documentsOnModeration };
};

export default useModerationDocuments;
